<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="time"
    transition="scale-transition"
    max-width="290px"
    min-width="290px"
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="time"
        :label="label"
        readonly
        outlined
        filled
        dense
      >
        <template v-slot:append-outer>
          <v-icon
            v-bind="attrs"
            v-on="on"
            :color="disabled ? '' : 'info'"
            :title="disabled ? '' : 'Seleccionar hora'"
            :disabled="disabled"
          >
            fas fa-clock
          </v-icon>
        </template>
      </v-text-field>
    </template>
    <v-time-picker
      v-if="menu"
      v-model="time"
      format="24hr"
      :min="horario_restringido ? $store.state.horarios_turno.desde : ''"
      :max="horario_restringido ? $store.state.horarios_turno.hasta : ''"
      :allowed-minutes="allowedStep"
      full-width
      @click:minute="$refs.menu.save(time)"
    ></v-time-picker>
  </v-menu>
</template>

<script>
export default {
  data () {
    return {
      menu: false
    }
  },
  async created () {
    // si no existen los horarios, los trae de nuevo
    if (!this.$store.state.horarios_turno) {
      this.$store.state.loading = true
      await this.$store.dispatch('get_horarios_turno')
        .then(() => {
          // todo ok
        })
        .catch(error => {
          this.$swal.fire({
            icon: 'error',
            title: 'Error al obtener los horarios',
            text: error,
          })
        })
      this.$store.state.loading = false
    }
  },
  props: {
    hora: String, // en formato HH:mm
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    horario_restringido: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    time: {
      get () {
        return this.hora
      },
      set (value) {
        this.$emit('update:hora', value)
      }
    }
  },
  methods: {
    allowedStep: m => m % 5 === 0
  }
}
</script>